import { createContext } from 'react';

import { TimeseriesToolbarInternalProps } from '../types/toolbar.js';

export const TimeseriesToolbarContext = createContext<
  TimeseriesToolbarInternalProps | undefined
>(undefined);

TimeseriesToolbarContext['displayName'] = 'TimeseriesToolbarContext';
